const tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let players = [];

function embedYouTubeVideo(container, videoID) {
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoID}?enablejsapi=1&loop=1&controls=0&mute=1`;
    iframe.frameBorder = '0';
    iframe.allowFullscreen = true;
    iframe.width = "100%";
    iframe.height = "auto";
    container.appendChild(iframe);
    
    return iframe;
}

function onYouTubeIframeAPIReady() {
    const containers = document.querySelectorAll('.pigeon-video-with-text--video');
    containers.forEach(container => {
        const videoID = container.dataset.videoId;
        const iframe = embedYouTubeVideo(container, videoID);
        const player = new YT.Player(iframe, {
          
        });
        players.push(player);
    });
}

const observer = new IntersectionObserver((entries) => {
    
    entries.forEach(entry => {
        const iframe = entry.target;
        const player = players.find(p => p.getIframe() === iframe);

        if (entry.isIntersecting) {
            if (player) {
                player.playVideo();
            }
        } else {
            if (player) {
                player.stopVideo();
            }
        }
    });
}, {
    threshold: 0.5
});

function checkVideoVisibility() {
  const iframes = document.querySelectorAll('iframe');
    iframes.forEach(iframe => {
        observer.observe(iframe);
  });
}

window.addEventListener('scroll', checkVideoVisibility);
window.addEventListener('resize', checkVideoVisibility);
checkVideoVisibility();